<template>
    <b-container
        fluid
        class="search-result-map"
        style="height: calc(100vh - 260px) !important;min-height: 500px;"
    >
        <div :class="{ overLayShadow: isOpenOverLayShadow }">
            <div class="projects clearfix customScrollBar">
                <div class="toolbar hidden-sm-and-down">
                    <div class="total">{{ $tc('searchResultPage.resultCount', mapData.count ) }}</div>
                </div>
                <div class="noResult" v-if="mapData.count == 0">
                    <h2>{{ $t('searchResultPage.noResult', { region: region_name } ) }}</h2>
                    <p>{{$t("searchResultPage.resultHint")}}</p>
                    <el-button
                        class="noResult_button"
                        type="button"
                        @click="clearAllFilter"
                    >{{$t("searchResultPage.removeFilters")}}</el-button>
                </div>
                <div v-for="(item, index) in mapData.result" :key="item.bk_project_id">
                    <el-card
                        :body-style="{ padding: '0px'}"
                        shadow="never"
                        :class="{iconCrown: item.top_10}"
                    >
                        <div @click="locatingMap(index)" class="locatingMap">
                            <div class="carousel">
                                <img
                                    v-lazy="item.pictures[0]"
                                    @error="errorImg"
                                    alt="project images"
                                />
                            </div>
                            <div class="block">
                                <div class="avg_price">{{ item.avg_sqft_price }}</div>
                                <span class="name" target="_blank">{{ item.name }}</span>
                                <!-- <div class="region">{{ item.region }} · {{ item.country }}</div> -->
                                <div
                                    class="min_price"
                                >{{$t('searchResultPage.card.startingPrice')}} {{ item.min_unit_price }}</div>
                                <div class="card-btn">
                                    <a
                                        class="view-project"
                                        @click="locatingMap(index)"
                                    >{{ $t('searchResultPage.viewMap_btn')}}</a>
                                    <a
                                        class="view-project"
                                        :href="item.url"
                                        target="_blank"
                                    >{{ $t('searchResultPage.viewProject_btn')}}</a>
                                </div>
                                <div class="livable_score" v-if="item.score">
                                    <el-progress
                                        type="circle"
                                        :percentage="parseFloat(item.score)"
                                        :show-text="false"
                                        color="#447ef6"
                                        :stroke-width="3"
                                        :width="45"
                                    ></el-progress>
                                    <div class="score">{{ item.score }}</div>
                                    <div class="overscore">{{ $t('searchResultPage.overall_score')}}</div>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>
            <div class="mapbox-custom">
                <div id="map" style="height: calc(100vh - 260px) !important;min-height: 500px;"></div>
                <div class="gradient_explanation">
                    <div class="color_square_word">
                        <span>{{$t("searchResultPage.highest")}}</span>
                        <span class="title">{{$t("searchResultPage.momentumScoere")}}</span>
                        <span>{{$t("searchResultPage.lowest")}}</span>
                    </div>
                    <div class="color_square">
                        <ul>
                            <li class="gradient"></li>
                            <li class="gradient"></li>
                            <li class="gradient"></li>
                            <li class="gradient"></li>
                            <li class="gradient"></li>
                            <li class="gradient"></li>
                            <li class="gradient"></li>
                            <li class="gradient"></li>
                            <li class="gradient"></li>
                            <li class="gradient"></li>
                            <li class="gradient"></li>
                            <li class="gradient"></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </b-container>
</template>

<script>
window.mapboxgl = require("mapbox-gl");
require("../../node_modules/mapbox-gl/dist/mapbox-gl.css");
var MapboxLanguage = require("@mapbox/mapbox-gl-language");

let map,
    loading,
    fill_color = [],
    geoMarkers;
export default {
    name: "SearchResultMap",
    props: [
        "mapData",
        "regionName",
        "count",
        "isOpenOverLayShadow",
        "apiJenks",
        "apiGeoRegionId",
        "region_name"
    ],
    data() {
        return {};
    },
    mounted() {
        this.init();
    },

    methods: {
        loading() {
            loading = this.$loading({
                lock: true,
                target: ".search-result-map",
                text: this.$t("searchResultPage.loading"),
                color: "#3b6bbf",
                background: "rgba(255, 255, 255, 0.8)"
            });
        },

        init() {
            mapboxgl.accessToken =
                "pk.eyJ1IjoiY2JvZ2FyIiwiYSI6ImNpZmk5cWc3eGJrb2VzNG03ZDZycTJ4dnEifQ.trBe09jujDgOddPyFxGwgg";
            let geoCenter;
            // init the map
            map = new mapboxgl.Map({
                container: "map",
                style: "mapbox://styles/mapbox/streets-v9",
                center: geoCenter,
                zoom: 10
            });

            let regionName = this.$root.regionQuery;

            this.$http
                .get(
                    `https://api.mapbox.com/geocoding/v5/mapbox.places/${regionName}.json?access_token=${mapboxgl.accessToken}&autocomplete=true`
                )
                .then(rep => {
                    geoCenter = rep.body.features[0].center;
                    map.setCenter(geoCenter);
                });

            map.addControl(new mapboxgl.NavigationControl());

            map.addControl(
                new MapboxLanguage({
                    defaultLanguage:
                        this.$root.cookie.acreage == "en" ? "en" : "zh-Hans",
                    supportedLanguages: ["zh-Hans", "en"]
                })
            );

            this.updateMap();
        },

        updateMap() {
            if (!this.apiGeoRegionId) {
                return;
            }

            if (fill_color[0] != "interpolate") {
                let num_classes = 10;
                let min_opacity = 0.01;
                let max_opacity = 0.9;
                let step_opacity = (max_opacity - min_opacity) / num_classes;

                let r = 59;
                let g = 107;
                let b = 191;

                let r_step = (255 - r) / num_classes;
                let g_step = (255 - g) / num_classes;
                let b_step = (255 - b) / num_classes;

                r = 255;
                g = 255;
                b = 255;

                fill_color.push("interpolate", ["linear"], ["get", "score"]);
                let tmp_opacity = min_opacity;
                for (let i = 1; i <= this.apiJenks.length; i++) {
                    fill_color.push(this.apiJenks[i - 1]);
                    fill_color.push(
                        "rgba(" +
                            r +
                            "," +
                            g +
                            "," +
                            b +
                            ", " +
                            tmp_opacity +
                            ")"
                    );
                    r -= r_step;
                    g -= g_step;
                    b -= b_step;
                    tmp_opacity += step_opacity;
                }
            }

            map.loadImage("../../../static/img/marker-blue.png", function(
                error,
                image
            ) {
                image.height = "30";
                image.width = "18";
                image.style = "z-index:100;";
                if (error) throw error;
                map.addImage("marker", image);
            });

            this.loading();
        },

        updateMarkers() {
            geoMarkers = {
                id: "places",
                type: "symbol",
                source: {
                    type: "geojson",
                    data: {
                        type: "FeatureCollection",
                        features: []
                    }
                },
                layout: {
                    "icon-image": "marker",
                    "icon-allow-overlap": true
                }
            };

            let field = {
                overallScore: "Overall Score",
                startingPrice: "Starting Price"
            };
            if (this.$root.cookie.acreage == "zh") {
                field = {
                    overallScore: "总体得分",
                    startingPrice: "起售价"
                };
            }
            let view_project =
                this.$root.cookie.acreage == "en" ? "View Project" : "查看详情";
            this.mapData.result.forEach(item => {
                let iconCrown = "";
                if (item.top_10) iconCrown = "iconCrown";
                geoMarkers.source.data.features.push({
                    type: "Feature",
                    properties: {
                        message:
                            "<a class='tooltip-box " +
                            iconCrown +
                            "' href='" +
                            item.url +
                            "' target='_blank' ><img class='tooltip-img' src='" +
                            item.pictures[0] +
                            "'/>" +
                            "<div class='tooltip-common'><p class='tooltip-per-price'>" +
                            item.avg_sqft_price +
                            "</p><p class='tooltip-name'>" +
                            item.name +
                            "</p><p>" +
                            field.overallScore +
                            " " +
                            item.score +
                            "</p><p class='tooltip-starting-price'>" +
                            field.startingPrice +
                            " " +
                            item.min_unit_price +
                            "</p>" +
                            "</div></a>" +
                            "<a class='view-project'" +
                            "href='" +
                            item.url +
                            "' target='_blank' >" +
                            view_project +
                            "</a>",
                        top_10: item.top_10,
                        id: item.id
                    },
                    geometry: {
                        type: "Point",
                        coordinates: [item.longitude, item.latitude]
                    }
                });
            });

            if (map.isStyleLoaded()) {
                map.getSource("places").setData(geoMarkers.source.data);
            }

            let apiGeoRegionId = this.apiGeoRegionId;

            map.on("load", function(e) {
                // map.setLayoutProperty('state-label', 'text-field', ["coalesce",["get", "name_zh-Hans"], ["get", "name_en"]]);
                // map.setLayoutProperty('marine-label', 'text-field', ["coalesce",["get", "name_zh-Hans"], ["get", "name_en"]]);
                // map.setLayoutProperty('place-label', 'text-field', ["coalesce",["get", "name_zh-Hans"], ["get", "name_en"]]);
                // map.setLayoutProperty('airport-label', 'text-field', ["coalesce",["get", "name_zh-Hans"], ["get", "name_en"]]);
                // map.setLayoutProperty('poi-label', 'text-field', ["coalesce",["get", "name_zh-Hans"], ["get", "name_en"]]);
                // map.setLayoutProperty('road-label', 'text-field', ["coalesce",["get", "name_zh-Hans"], ["get", "name_en"]]);

                loading.close();

                if (map.getSource("voronoi-tiles")) {
                    return;
                }

                map.addSource("voronoi-tiles", {
                    type: "vector",
                    url: "mapbox://cbogar.voronoi-region-" + apiGeoRegionId
                });

                map.addLayer({
                    id: "terrain-data",
                    type: "fill",
                    source: "voronoi-tiles",
                    "source-layer": "voronoi-region-" + apiGeoRegionId,
                    paint: {
                        "fill-color": fill_color,
                        "fill-outline-color": "rgba(59, 107, 191, 0.05)"
                    }
                });

                if (map.getLayer("places")) {
                    map.removeLayer("places");
                }
                map.addLayer(geoMarkers);
            });

            map.on("click", "places", function(e) {
                var coordinates = e.features[0].geometry.coordinates.slice();
                var message = e.features[0].properties.message;

                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] +=
                        e.lngLat.lng > coordinates[0] ? 360 : -360;
                }

                new mapboxgl.Popup({ offset: 15, anchor: "bottom" })
                    .setLngLat(coordinates)
                    .setHTML(message)
                    .addTo(map);

                map.easeTo({
                    center: e.lngLat,
                    offset: [0, 100]
                });
            });

            map.on("mouseenter", "places", function() {
                map.getCanvas().style.cursor = "pointer";
            });

            // Change it back to a pointer when it leaves.
            map.on("mouseleave", "places", function() {
                map.getCanvas().style.cursor = "";
            });
        },

        locatingMap(index) {
            let item = this.mapData.result[index];
            this.flyToStore(item);
            this.createPopUp(item);
        },
        flyToStore(item) {
            map.flyTo({
                center: [item.longitude, item.latitude],
                zoom: 12,
                offset: [0, 100]
            });
        },

        createPopUp(item) {
            let popUps = document.getElementsByClassName("mapboxgl-popup");
            // Check if there is already a popup on the map and if so, remove it
            if (popUps[0]) popUps[0].remove();

            let field = {
                overallScore: "Overall Score",
                startingPrice: "Starting Price"
            };
            if (this.$root.cookie.acreage == "zh") {
                field = {
                    overallScore: "总体得分",
                    startingPrice: "起售价"
                };
            }
            let view_project =
                this.$root.cookie.acreage == "en" ? "View Project" : "查看详情";
            let iconCrown = "";
            if (item.top_10) iconCrown = "iconCrown";
            let popup = new mapboxgl.Popup({ offset: 30, anchor: "bottom" })
                .setLngLat([item.longitude, item.latitude])
                .setHTML(
                    "<a class='tooltip-box " +
                        iconCrown +
                        "' href='" +
                        item.url +
                        "' target='_blank' ><img class='tooltip-img' src='" +
                        item.pictures[0] +
                        "'/>" +
                        "<div class='tooltip-common'><p class='tooltip-per-price'>" +
                        item.avg_sqft_price +
                        "</p><p class='tooltip-name'>" +
                        item.name +
                        "</p><p>" +
                        field.overallScore +
                        " " +
                        item.score +
                        "</p><p class='tooltip-starting-price'>" +
                        field.startingPrice +
                        " " +
                        item.min_unit_price +
                        "</p>" +
                        "</div></a>" +
                        "<a class='view-project'" +
                        "href='" +
                        item.url +
                        "' target='_blank' >" +
                        view_project +
                        "</a>"
                )
                .addTo(map);
        },

        switchView() {
            this.$emit("view", "list");
        },

        clearAllFilter() {
            this.$emit("clearAll", true);
        },

        onoffswitchHeatmap(val) {
            if (val) {
                map.setLayoutProperty("terrain-data", "visibility", "visible");
            } else {
                map.setLayoutProperty("terrain-data", "visibility", "none");
            }
        },

        errorImg: function(param) {
            param.target.src = `${defaultImg}`;
        }
    },

    watch: {
        "mapData.heatmapMode": {
            handler(newVal, oldVal) {
                this.onoffswitchHeatmap(newVal);
            },
            deep: true
        },
        "mapData.result": {
            handler(newVal, oldVal) {
                this.updateMarkers();
            }
        }
    }
};
</script>

<style scoped>
.search-result-map {
    padding: 0;
    position: relative;
}

.overLayShadow {
    position: relative;
    height: calc(100vh - 260px) !important;
    min-height: 500px;
}

.overLayShadow:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 4;
    background: rgba(255, 255, 255, 0.85);
}

.projects {
    height: calc(100vh - 260px) !important;
    min-height: 500px;
    overflow-y: auto;
    width: 320px;
    padding: 23px 11px 23px 23px;
}

.toolbar .total {
    margin-bottom: 23px;
    width: 100%;
    font-size: 0.16rem;
    color: rgb(51, 51, 51);
}

.projects >>> .locatingMap {
    cursor: pointer;
}
.projects >>> .el-card {
    margin-bottom: 16px;
    border-radius: 3.4px;
    box-shadow: 0 2px 7px 0 rgba(155, 155, 155, 0.5);
    border: solid 0.9px rgb(216, 216, 216);
    background-color: var(--white);
    height: auto;
    min-height: 250px;
}

.projects >>> .el-card img {
    height: 154px;
    width: 100%;
    object-fit: cover;
}

.projects >>> .el-card .block {
    position: relative;
    padding: 0 12px;
}

.projects >>> .el-card .block .avg_price {
    font-family: GothamBold;
    font-weight: bold;
    color: rgb(51, 51, 51);
    margin: 10px 0 7px;
    height: 10px;
    line-height: 10px;
}

.projects >>> .el-card .block .name {
    font-family: GothamBold;
    font-size: 13.7px;
    font-weight: bold;
    letter-spacing: 0.6px;
    color: rgb(51, 51, 51);
    margin-bottom: 0.05rem;
    display: block;
    margin-right: 80px;
    height: auto;
    word-break: break-word;
}

.projects >>> .el-card .block .region {
    font-size: 0.14rem;
    letter-spacing: 0.6px;
    color: #666;
    margin-right: 80px;
    margin-bottom: 0.1rem;
}

.projects >>> .el-card .block .min_price {
    font-family: GothamBook;
    font-size: 0.12rem;
    line-height: 1.05;
    color: #666;
    height: 0.13rem;
    margin-bottom: 0.1rem;
}

.projects >>> .el-card .block .card-btn {
    width: 100%;
    text-align: left;
    height: 21px;
    margin-bottom: 11px;
}

.projects >>> .el-card .block .card-btn .view-project {
    height: 21px;
    padding: 0 7px;
    line-height: 21px;
    border-radius: 9.5px;
    color: var(--windows-blue);
    font-family: GothamMedium;
    border: solid 1px var(--windows-blue);
    text-align: center;
    font-size: 11px;
    margin-top: -25px;
    display: inline-block;
}

.projects >>> .el-card .block .livable_score {
    position: absolute;
    top: 20px;
    right: 12px;
    width: 60px;
    text-align: center;
}

.projects >>> .el-card .block .score {
    font-family: GothamBold;
    font-size: 11.5px;
    font-weight: bold;
    letter-spacing: 0.4px;
    text-align: center;
    color: rgb(12, 37, 61);
    position: absolute;
    top: 15px;
    left: 17px;
}

.projects >>> .el-card .block .overscore {
    width: 100%;
    font-family: GothamBook;
    font-size: 9px;
    line-height: 1;
    text-align: center;
    color: var(--brownish-grey);
    position: absolute;
    bottom: -16px;
}

.projects >>> .el-card .block .livable_score p {
    font-family: GothamMedium;
    font-size: 10px;
    font-weight: 500;
    margin-top: 12px;
    text-align: center;
    color: var(--brownish-grey);
}

.projects >>> .el-card .block svg {
    height: auto;
    width: auto;
}

canvas.mapboxgl-canvas:focus,
.mapboxgl-map {
    outline: none;
}

.search-result-map >>> .iconCrown {
    position: relative;
}

.search-result-map >>> .iconCrown:before {
    content: "";
    position: absolute;
    right: -50px;
    top: -50px;
    display: inline-block;
    z-index: 3;
    width: 100px;
    height: 100px;
    transform: rotate(45deg);
    background-color: #0d253f;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
}

.search-result-map >>> .iconCrown:after {
    content: "";
    position: absolute;
    right: 10px;
    top: 12px;
    display: inline-block;
    z-index: 3;
    width: 24px;
    height: 20px;
    background: url("../../../website_20/static/img/stacked-group-4.svg")
        no-repeat;
    background-position: 2px -2px;
}

.mapbox-custom {
    position: absolute;
    top: 0;
    right: 0;
    width: calc(100% - 320px);
    height: calc(100vh - 260px) !important;
    min-height: 500px;
}

.gradient_explanation {
    padding: 15px;
    position: absolute;
    right: 23px;
    bottom: 25px;
    border-radius: 3px;
    width: 300px;
    height: 63px;
    box-shadow: 0 2px 7px 0 rgba(155, 155, 155, 0.5);
    background-color: rgba(255, 255, 255, 0.85);
}
.gradient_explanation .color_square {
    display: inline-block;
}

.gradient_explanation .color_square ul {
    height: 14px;
    display: inline-block;
    background: linear-gradient(to right, #3b6bbf 0%, #3775b80c 105%);
}
.gradient_explanation .color_square ul .gradient {
    display: inline-block;
    height: 100%;
    width: 4px;
    float: left;
    margin-left: 18.5px;
    background: #fff;
}

.gradient_explanation .color_square_word {
    padding-right: 4px;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
}

.gradient_explanation .color_square_word span {
    font-family: GothamBook;
    font-size: 12px;
    color: var(--windows-blue);
    height: 10px;
    margin-bottom: 8px;
}

.gradient_explanation .color_square_word .title {
    display: inline-block;
    vertical-align: top;
    font-family: GothamBook;
    font-size: 12px;
    text-align: center;
    color: #333333;
}

#map >>> .mapboxgl-ctrl.mapboxgl-ctrl-attrib {
    display: none;
}

#map >>> .mapboxgl-canvas-container {
    height: 100%;
}

#map >>> .mapboxgl-popup {
    z-index: 3;
    max-width: 400px;
    font: 12px/20px "Helvetica Neue", Arial, Helvetica, sans-serif;
}

#map >>> .mapboxgl-popup-content {
    padding: 0;
    border-radius: 3.4px;
    overflow: hidden;
    box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.5);
    width: 265px;
}

#map >>> .mapboxgl-popup-close-button {
    z-index: 1;
    right: unset;
    left: 0;
    color: #fff;
}

#map >>> .tooltip-box {
    display: inline-block;
    width: 100%;
    height: 100%;
}
#map >>> .tooltip-box .tooltip-img {
    width: 100%;
    height: 120px;
    background-repeat: no-repeat;
    background-size: cover;
    object-fit: cover;
}
#map >>> .tooltip-box .tooltip-common {
    padding: 10px 11.5px;
    padding-bottom: 41.5px;
}

#map >>> .tooltip-box .tooltip-common p.tooltip-per-price {
    font-family: GothamMedium;
    font-size: 11.5px;
    color: #333;
    margin-bottom: 7px;
    word-break: break-word;
}
#map >>> .tooltip-box .tooltip-common p {
    height: 12px;
    line-height: 12px;
    font-size: 11.5px;
    font-family: GothamBook;
    color: var(--brownish-grey);
    margin-bottom: 7px;
}
#map >>> .tooltip-box p.tooltip-name {
    font-family: GothamMedium;
    color: var(--windows-blue);
    height: auto;
    font-size: 13.8px;
    margin-bottom: 7px;
    position: relative;
}

#map >>> .tooltip-box p.tooltip-starting-price {
    margin: 0;
}

#map >>> .mapboxgl-popup-content .view-project {
    width: 78px;
    height: 21px;
    line-height: 21px;
    border-radius: 9.5px;
    border: solid 1px var(--windows-blue);
    text-align: center;
    font-size: 10px;
    margin-top: -25px;
    display: inline-block;
    position: absolute;
    right: 13px;
    bottom: 10px;
}
/* #map >>> .tooltip-box p.tooltip-name:after {
    content: "";
    height: 10px;
    width: 10px;
    position: absolute;
    right: 0;
    top: 2px;
    background: url("../../../website_20/static/img/arrow-right.svg") no-repeat;
    background-size: cover;
} */

#map >>> .marker-red {
    background: url("../../../website_20/static/img/marker-red.svg") no-repeat;
    width: 18px;
    height: 29px;
    z-index: 2;
}
#map >>> .marker-blue {
    cursor: pointer;
    background: url("../../../website_20/static/img/marker-blue.svg") no-repeat;
    width: 18px;
    height: 29px;
}
#map >>> .marker-blue:hover {
    z-index: 2;
}
#map >>> .iconCrown {
    position: relative;
}
#map >>> .iconCrown:before {
    content: "";
    position: absolute;
    right: -44px;
    top: -44px;
    display: inline-block;
    z-index: 2;
    width: 76px;
    height: 76px;
    transform: rotate(45deg);
    background-color: #0d253f;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
}

#map >>> .iconCrown:after {
    content: "";
    position: absolute;
    right: 6px;
    top: 6px;
    display: inline-block;
    z-index: 2;
    width: 14px;
    height: 14px;
    background: url("../../../website_20/static/img/stacked-group-4.svg")
        no-repeat;
    background-position: 2px -2px;
    background-size: cover;
}

.noResult {
    padding: 20px 0;
    margin-bottom: 35px;
    border-bottom: 1px solid #d8d8d8;
}

.noResult h2 {
    font-family: GothamBold;
    font-size: 22px;
    font-weight: bold;
    line-height: 1.4;
    color: rgb(51, 51, 51);
    margin-bottom: 20px;
}

.noResult p {
    margin-top: 5px;
    font-family: GothamBook;
    font-size: 16px;
    color: rgb(51, 51, 51);
}

.noResult .el-button {
    height: 40px;
    box-shadow: 0 8px 15px 0 rgba(127, 156, 207, 0.5);
    padding: 0;
    border: 0;
    background-color: var(--windows-blue);
    width: 180px;
    font-family: GothamMedium;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.4px;
    text-align: center;
    color: var(--white);
    margin-top: 20px;
}

.noResult .el-button >>> span {
    font-family: GothamBook;
    display: inline-block;
    vertical-align: middle;
}

.noResult .el-button:hover {
    background-color: var(--light-navy);
}

@media (max-width: 992px) {
    .projects {
        display: none;
    }
    .mapbox-custom {
        width: 100%;
    }
    #map {
        width: 100%;
    }
    .gradient_explanation {
        width: 240px;
    }
    .gradient_explanation .color_square ul .gradient {
        margin-left: 13.5px;
    }
}

@media (max-width: 520px) {
    .gradient_explanation {
        display: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/SearchResultMap.vue